export enum PrinterType {
  IP_PRINTER = "IP_PRINTER",
  ZEBRA_IP_PRINTER = "ZEBRA_IP_PRINTER",
  BUILT_IN_SUNMI = "BUILT_IN_SUNMI",
  SUNMI_CLOUD = "SUNMI_CLOUD",
}
